import { render, staticRenderFns } from "./LunchNotes.vue?vue&type=template&id=3f71eb3e&"
import script from "./LunchNotes.vue?vue&type=script&lang=js&"
export * from "./LunchNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports